import type { FC, ReactElement, ReactNode } from 'react';
import OnboardingBackground from './components/OnboardingBackground';
import OnboardingPageHeader from './components/OnboardingPageHeader';
import { Wrapper } from './styles';

type OnboardingPageWrapperProps = {
    accent?: ReactElement;
    accentSize?: 'lg' | 'sm';
    canLogout?: boolean;
    children: ReactNode;
};

const OnboardingPageWrapper: FC<OnboardingPageWrapperProps> = ({ canLogout, accent, accentSize, children }) => (
    <Wrapper>
        <OnboardingPageHeader canLogout={canLogout ?? false} />
        <OnboardingBackground accent={accent} accentSize={accentSize}>
            {children}
        </OnboardingBackground>
    </Wrapper>
);

export default OnboardingPageWrapper;
